import { render, staticRenderFns } from "./ToggleStarted.vue?vue&type=template&id=3b1efd1a&v-slot%3Amodal-header=true&"
import script from "./ToggleStarted.vue?vue&type=script&lang=js&"
export * from "./ToggleStarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports